import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';

import {
    ActionsColumn,
    BrandModelColumn,
    IdColumn,
    PrefixColumn,
} from './components';
import {
    Box,
    Container,
    Flex,
    Group,
    MultiSelect,
    Portal,
    Select,
    Text,
} from '@mantine/core';
import { getMessageGroups, getMobileDevices } from '../../../../http/apiClient';
import {
    useDebouncedCallback,
    useDisclosure,
    useLocalStorage,
} from '@mantine/hooks';
import { useMemo, useState } from 'react';

import FilterTopToolbar from '../../../common/tables/toolbars/FilterTopToolbar';
import FiltersMultiSelect from '../../../common/filtersMultiSelect/FiltersMultiSelect';
import JsonOptionsColumn from '../../../common/tables/columns/JsonOptionsColumn';
import JsonOptionsModal from '../../../modals/options/JsonOptionsModal';
import { MantineReactTable } from 'mantine-react-table';
import { TextColumn } from '../../../common';
import { usePaginatedQuery } from '../../../../http/queries/usePaginatedQuery';

const testCampaign = {
    id: 2,
    name: '',
};

const MobileDevicesView = ({ ...props }) => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [activeFilters, setActiveFilters] = useState([]);
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50,
    });

    const [jsonModalProps, setJsonModalProps] = useState({});
    const [
        optionsModalOpen,
        { open: openOptionsModal, close: closeOptionsModal },
    ] = useDisclosure();

    const filterDebounce = useDebouncedCallback((query) => {
        setGlobalFilter(query);
    }, 600);

    const {
        isLoading,
        isError,
        error,
        data: paginatedData,
    } = usePaginatedQuery({
        queryFn: (queryParams) => getMobileDevices(queryParams),
        queryKey: ['mobile_devices'],
        refetchInterval: 15_0000,
        globalFilter,
        pagination,
        sorting,
    });

    const handleShowOptions = (accessorKey, jsonObj) => {
        const optionTitles = {
            imsOptions: 'IMS Options',
            mmsOptions: 'MMS Options',
            campaignOptions: 'Campaign Options',
        };
        setJsonModalProps({
            header: optionTitles[accessorKey] || 'Options',
            jsonObj: jsonObj,
        });
        openOptionsModal();
    };

    const { data: devices, pagination: dataPagination } = paginatedData || {};
    const columns = useMemo(
        () => [
            IdColumn(),
            PrefixColumn(),
            BrandModelColumn(),
            TextColumn({
                accessorKey: 'modelIdentifier',
                header: 'Model Indentifier',
            }),
            TextColumn({
                accessorKey: 'modelCode',
                header: 'Model Code',
            }),
            TextColumn({
                accessorKey: 'notes',
                header: 'Notes',
            }),
            JsonOptionsColumn({
                header: 'IMS Options',
                id: 'imsOptions',
                accessorKey: 'imsOptions',
                onClick: handleShowOptions,
            }),
            JsonOptionsColumn({
                header: 'MMS Options',
                id: 'mmsOptions',
                accessorKey: 'mmsOptions',
                onClick: handleShowOptions,
            }),
        ],
        [devices]
    );

    const tableData = useMemo(
        () => (isLoading ? [] : devices),
        [devices, isLoading]
    );

    const [columnVisibility, setColumnVisibility] = useLocalStorage({
        key: 'devices-table-visibility', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const [columnSizing, setColumnSizing] = useLocalStorage({
        key: 'devices-group-table-sizing', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const handleVisibilityChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnVisibility((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handlSizeChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnSizing((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handleFilterChange = (queryStr) => {
        filterDebounce(queryStr);
    };

    const tableProps = {
        columns: columns,
        data: tableData,
        enableRowActions: false,
        enableColumnResizing: true,
        enableColumnActions: false,
        enableSorting: false,
        enableTopToolbar: true,
        enableGlobalFilter: true,
        enableFilters: false,
        enableStickyHeader: true,
        enableDensityToggle: false,
        positionActionsColumn: 'last',
        layoutMode: 'semantic',
        mantineSearchTextInputProps: {
            placeholder: 'Search Devices',
            miw: 200,
        },
        mantineTableContainerProps: {
            style: {
                minHeight: '80vh',
            },
        },
        positionGlobalFilter: 'left',
        renderTopToolbarCustomActions: ({ ...props }) => (
            <FilterTopToolbar
                activeFilters={activeFilters}
                filterOptions={[
                    {
                        group: 'Brand',
                        items: [
                            { label: 'Apple', value: 'apple' },
                            { label: 'Android', value: 'android' },
                        ],
                    },
                ]}
                onFilterChange={setActiveFilters}
            />
        ),
        //renderRowActions: ActionsColumn,

        manualPagination: true,
        manualSorting: true,
        onColumnVisibilityChange: handleVisibilityChange,
        onColumnSizingChange: handlSizeChange,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onGlobalFilterChange: handleFilterChange,
        rowCount: dataPagination?.totalItems || 0,
        pageCount: dataPagination?.totalPages || 1,

        initialState: {
            columnVisibility,
            pagination,
            isLoading,
            showGlobalFilter: true,
        },
        state: {
            isLoading,
            pagination,
            columnVisibility,
            columnSizing,
            showAlertBanner: isError,
            showProgressBars: isLoading,
            sorting,
            density: 'xs',
        },
    };

    return (
        <Container fluid>
            <MantineReactTable {...tableProps} />
            <JsonOptionsModal
                {...jsonModalProps}
                opened={optionsModalOpen}
                close={closeOptionsModal}
            />
        </Container>
    );
};
export default MobileDevicesView;
